import { Container, Grid, Skeleton } from '@mui/material'

import CommonBackButton from '../../../atoms/CommonBackButton/CommonBackButton'
import useTrackPageView from "../../../../helpers/hooks/use-track-page-view"

import styles from './VoucherWallet.module.css'
import { useVouchermaticRepository } from '../../../../repositories/Vouchermatic/use-vouchermatic-repository'
import { useContext, useEffect } from 'react'
import { UserContext } from '../../../../stores/User/UserStore'
import SplashScreenGuard from '../../../../router/guards/SplashScreenGuard'

const VoucherWallet = () => {
    useTrackPageView(`Vouchermatic Wallet`)

    const { fetchWallet } = useVouchermaticRepository()
    const { state: userState } = useContext(UserContext)

    useEffect(() => {
        if (!userState.vouchermaticWallet){
            fetchWallet(userState.membership?.data?.id?.toString() || ``)
        }
    }, [])

    if (!userState.vouchermaticWallet){
        return <Skeleton width={`100%`} height={`100%`} variant="rectangular" />
    }

    return <Container className={styles.container}>
        <SplashScreenGuard>
            <>
                <CommonBackButton />
                <Grid className={styles.content}>
                    <iframe className={styles.iframe} width="100%" src={userState.vouchermaticWallet} title="GeeksforGeeks" />
                </Grid>
            </>
        </SplashScreenGuard>
    </Container>
}

export default VoucherWallet